import { faMagnifyingGlass, faPaperclip, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import ImageUpload from '../../../Components/common/ImageUpload.js';
import { Link } from 'react-router-dom';
import ActivityComments from '../../../Components/common/ActivityComments.js';
import { Badge, Button, Tab, Tabs, Modal } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import Export from "../../../assets/images/export.svg";
import edit from "../../../assets/images/edit.png";
import Cargoplane from "../../../assets/images/plane.svg";
import { withRFSToken } from '../../../Services/axios.js';
import { GETULDDETAILS, MVTHDETAILS } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';
import { CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const Planning = ({ AddClick }) => {

    const tabName = localStorage.getItem('grid_tab');
    const [activeTab, setActiveTab] = useState(tabName || 'Active');
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
        // Trash: []

    });
    const isMounted = useRef(false);

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const [filterApplied, setFilterApplied] = useState(false);
    const [totalRows, setTotalRows] = useState({});
    const [totalRowsR, setTotalRowsR] = useState(0);
    const [gridSelect, setGridSelect] = useState([]);
    const [editData, setEditData] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        localStorage.setItem('grid_tab', tab);
        //const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }

    };

    let checkUlds = [];
    let filterForCheck = false;

    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData({ Active: {} });
        localStorage.removeItem("uld_id");
        isMounted.current = true;
    }, []);


    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
            const endpoint = tabType === 'A'
                ? 'uld-control/active-uld-planning'
                : 'uld-control/archive-uld-planning';
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_id', type: 'string' },
                    { name: 'created', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'receiving_airline', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'on_loan', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'status_name', type: 'string' },
                    { name: 'archive_date', type: 'string' },
                    { name: 'sender_handler', type: 'string' },

                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}forwarder-uld-control/get-uld-list?tab_name=${tabType}&main_tab=P`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    setTotalRows({ totalUlds: data.activeCount });
                    setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            let columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                    },
                    width: '5%', filterable: false,
                },
                {
                    text: 'Created', filtertype: 'range', datafield: 'created', width: '8%', cellclassname: '',
                    // cellsrenderer: function (row, column, value, defaultHtml, columnSettings, rowData) {
                    //     const createdValue = value || rowData.archive_date;
                    //     return createdValue || '';  
                    //   }
                },
                { text: 'ULD Number', filtertype: 'input', datafield: 'uld_number', width: '12%', cellclassname: '', },
                {
                    text: 'Status',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
                        if (cellValue.status === 'Build Up') {
                            return '<div class="jqx-grid-cell-left-align fw_planed">' + cellValue.status_name + '</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align fw_progess">' + cellValue.status_name + '</div>';
                        }
                    },
                    datafield: 'status_name', width: '8%', filterable: false,
                },
                { text: 'Type Code', filtertype: 'input', datafield: 'type_code', width: '6%', cellclassname: '', },
                { text: 'Serial Number', filtertype: 'input', datafield: 'serial_number', width: '8%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'input', datafield: 'owner_code', width: '6%', cellclassname: '', },
                {
                    text: 'Condition Code', filtertype: 'checkedlist', filterable: true,
                    filteritems: [
                        { label: 'Serviceable', value: 'SER' },
                        { label: 'Damaged', value: 'DAM' },
                        { label: 'Discarded', value: 'DIS' }
                    ],
                    datafield: 'condition_code', width: '8%', cellclassname: '',
                },
                {
                    text: 'Airline', filtertype: 'input', datafield: 'receiving_airline', width: '12%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {

                        return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.airline_name + '</div>';
                    },
                },
                { text: 'Station', filtertype: 'input', datafield: 'origin', width: '8%', cellclassname: '', },
                { text: 'Handler Name', filtertype: 'textbox', datafield: 'sender_handler', width: '8%', cellclassname: '', },
                { text: 'Airway Bill', filtertype: 'input', datafield: 'airway_bill', width: '8%', cellclassname: '', },

            ];
            if (activeTab === 'Archived') {
                columns = columns.filter(col => col.datafield !== 'status');
            }
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        localStorage.setItem('F_EditULD', rowData.id);
                        localStorage.setItem('grid_tab', activeTab);
                        localStorage.setItem('F_AddULD', "planning");
                        // window.location.href = '/ULDForwarder/AddULD'
                        AddClick()
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }

                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    loadDetails(args.uld_id);
                    // setSelectedRowData(args)
                }
            });
        }
    }, [gridData]);

    const loadDetails = (uldNumber) => {
        setDisLoading(true);
        CallApi({
            endPoint: 'forwarder-uld-control/get-uld-details',
            payload: { uld_id: uldNumber },
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    setSelectedRowData(innerData);
                } else {
                    toast.error(data.data.response_msg);
                }
                setDisLoading(false);
            },
            onError: (msg) => toast.error(msg)
        });
        // try {
        //     const res = await withRFSToken.post('uld-control/planning-stock-details', { uld_id: uldNumber });
        //     if (res.data.response_code === 200) {
        //         const innerData = res.data.response_data;
        //         setSelectedRowData(innerData);
        //         setDisLoading(false);
        //     } else {
        //         toast.error(res.data.response_msg);
        //         setDisLoading(false);
        //     }
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    };

    const movementHistoryClick = () => {
        try {
            // Check if selectedRowData is defined
            if (!selectedRowData) {
                throw new Error('Selected row data is not available.');
            }

            localStorage.removeItem('MHistory');
            const storageData = {
                ULD: selectedRowData,  // ULD Details section
                Form: {}  // Empty form section
            };
            localStorage.setItem('MHistory', JSON.stringify(storageData));
            localStorage.setItem('tab', 'assets');
            window.location.href = '/ULDControl/MovementHistory'
        } catch (error) {
            // Log the error for debugging purposes
            console.error('Error during navigation:', error.message);
            alert('An error occurred: ' + error.message); // Optional user alert
        }
    };

    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);


    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    const handleDetailsClick = async (history) => {

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }

        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }



    };
    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        }, 30);
    };

    const addUld = () => {
        localStorage.removeItem('F_EditULD');
        localStorage.setItem('F_AddULD', "planning");
        AddClick()
    }
    const [actArcModal, setActArcModal] = useState(false);
    const handleMoveToActArc = () => {
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            setActArcModal(true);
            // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
        }
    };
    const confirmMoveToActArc = async () => {

        const sendAction = activeTab == 'Active' ? 'I' : 'A';
        const uldNumbers = gridSelect && gridSelect.map(num => num.uld_id)
        try {
            const res = await withRFSToken.post('forwarder-action/active-archive-uld-planning', { id: uldNumbers, activity_status: sendAction })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        toast.success(res.data.response_msg);
                        // setGridSelect([]);
                        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        // fetchDataGrid()
                        // if (activeTab == 'Active') {
                        //     toast.success('ULD Data moved to Arhive');
                        //     fetchDataGrid()
                        // } else {
                        //     toast.success('ULD Data moved to Active');
                        //     fetchDataGridR()
                        // }
                        setActArcModal(false)
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    return (
        <>
            {/* <div className="">
                {console.log("hey checking")}
                <Header />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='FORWARDER' />
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-end mb-3 order_search'>
                                        <div className='search'>
                                            <div className="form-group has-search"> */}
            {/* <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                            <input type="text" className="form-control" placeholder="Search" /> */}
            {/* </div>

                                        </div>
                                    </div>
                                    <div className="lcontent"> */}
            <div className="mb-0 nestedtabs rounded">
                <div className='d-flex justify-content-between'>
                    <div className='d-flex'>
                        <div className='me-3'>
                            <button className="addtruck" variant="primary" onClick={addUld}>
                                <span> <FontAwesomeIcon icon={faPlus} /> Add ULD</span>
                            </button>
                        </div>

                        <span className="selected">
                            Selected ULD <Badge>{gridSelect.length}</Badge>
                        </span>
                    </div>
                    <div className='d-flex'>
                        <div className='ulddown'>
                            {activeTab === 'Active' && <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button>}
                            {activeTab === 'Archived' && <button onClick={handleMoveToActArc}> <img title='' src={Activ} /> Active </button>}
                            <button ><img src={Export} /> Download</button>
                        </div>
                    </div>

                </div>

            </div>
            <div className='maindiv'>
                <div className='trashdonload'>
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
                            {/* <Loader isLoading={isLoading} /> */}
                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_number} &nbsp;
                                <span className={selectedRowData.status_name == 'Build Up' ? 'fw_planed' : 'fw_progess'}>
                                    {selectedRowData.status_name}
                                </span>
                            </h3>
                            <div className='d-flex actbtn justify-content-between'>
                                <div className='d-flex'>
                                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                </div>
                                {/* <div className='viwall'>
                                                        <Link to='#'>View Details</Link>
                                                      </div> */}
                            </div>

                        </div>

                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"forwarder_uld"}
                            attachable_id={selectedRowData.id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.id)}
                        />
                        <ActivityComments
                            commentable_type={"forwarder_uld"}
                            commentable_id={selectedRowData.id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails(selectedRowData.id)}
                        />
                    </div>
                )}
            </div>
            {/* </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
            <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <h3>Selected {gridSelect.length > 1 ? "Row's" : 'Row'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
                        <p>Are you sure you want to move {gridSelect.length > 1 ? "Row's" : 'Row'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setActArcModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={confirmMoveToActArc}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            {/* </div>
            </div> */}
        </>
    )
}

export default Planning